import React from 'react';
import { Tabs } from 'antd';
import type { TabsProps } from 'antd';
import HaoyiTab from './HaoyiTab';
import Platform172Tab from './Platform172Tab';

const tabItems: TabsProps['items'] = [
  { key: 'haoyi', label: '号易', children: <HaoyiTab /> },
  { key: 'platform172', label: '172', children: <Platform172Tab /> },
];

const ExternalProductsPage: React.FC = () => (
  <div style={{ padding: 0, margin: 0, height: '100%' }}>
    <Tabs defaultActiveKey="haoyi" items={tabItems} style={{ height: '100%' }} />
  </div>
);

export default ExternalProductsPage;
